import { useQuery } from 'data-fetching-client';
import { GET_EMAIL_BY_CAMPAIGN_ID } from 'flow-doctor-lib/queries/EmailQueries';
const useEmailByCampaignId = ({
  portalId,
  emailCampaignId
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_EMAIL_BY_CAMPAIGN_ID, {
    variables: {
      portalId,
      emailCampaignId
    }
  });
  const dataToReturn = data ? data.emailByCampaignId[emailCampaignId] : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useEmailByCampaignId;